var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LockSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.499 8.25H4.49902C4.08481 8.25 3.74902 8.58579 3.74902 9V19.5C3.74902 19.9142 4.08481 20.25 4.49902 20.25H19.499C19.9132 20.25 20.249 19.9142 20.249 19.5V9C20.249 8.58579 19.9132 8.25 19.499 8.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.62402 8.25V4.875C8.62402 3.97989 8.9796 3.12145 9.61254 2.48851C10.2455 1.85558 11.1039 1.5 11.999 1.5C12.8941 1.5 13.7526 1.85558 14.3855 2.48851C15.0184 3.12145 15.374 3.97989 15.374 4.875V8.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.5424d92f07294b25885e3fd4e3753d85.svg";
export { ForwardRef as ReactComponent };